import { Header } from "components/Header"
import { SupplierForm } from "components/supplier-form"
import { ar } from "i18n/ar"

export default function CreateSupplier() {
  return (
    <>
      <Header title={ar.newSupplier} />
      <SupplierForm />
    </>
  )
}
